//@flow
import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { CallToAction } from 'components/atoms/callToAction';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  descriptionOne: string,
  descriptionTwo: string,
  projectRichTextOne?: string,
  projectRichTextTwo?: string,
  showCtaButton?: boolean,
  onClickCTA?: void,
  className?: string,
};

export const ArchitectProjectOverlayDescription = (props: Props) => {
  const {
    descriptionOne,
    descriptionTwo,
    projectRichTextOne,
    projectRichTextTwo,
    showCtaButton = false,
    onClickCTA,
    className,
  } = props;
  return (
    <>
      <span className={'description-one'}>{descriptionOne}</span>
      {showCtaButton && (
        <CallToAction
          text={'PROJECT DETAILS'}
          onClick={onClickCTA}
          mode={'light'}
          className={className}
        />
      )}
      <div className={'project-meta-description-container'}>
        <HTMLView
          html={projectRichTextOne}
          tagName={'div'}
          className={'project-meta-description-one'}
        />
        <HTMLView
          html={projectRichTextTwo}
          tagName={'div'}
          className={'project-meta-description-two'}
        />
      </div>
      <div className={'vertical-bar-container'}>
        <div className={'vertical-bar'} />
        <h2 className={'description-two'}>{descriptionTwo}</h2>
      </div>
    </>
  );
};
